export const ChartType = {
  orgHierarchy: 'orgHierarchy',
  processFlow: 'processFlow'
};
